import angular from 'angular';
import { RedCrossComponent } from './red-cross.component';
import { RedCrossConfig } from './red-cross.config';
import {
  StepPageModule,
  UCloudinaryImageDirectives,
} from '../../common/directives';

export const RedCrossModule = angular
  .module('app.steps.red-cross', [
    StepPageModule.name,
    UCloudinaryImageDirectives.name,
  ])
  .config(RedCrossConfig)
  .component('updRedCross', RedCrossComponent);
